import React, { useState } from "react";

const PhoneSection = () => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="phone-section-container"
      style={{
        width: "100%",
        height: "auto",
        padding: "0rem 4rem",
        justifyContent: "center",
        backgroundColor: "white",
        display: "flex",
        flexWrap: "wrap",
      }}
    >
      <div
        className="phone-section"
        style={{
          width: "1400px",
          height: "auto",
          display: "flex",
          gap: "5rem",
          flexWrap: "wrap",
        }}
      >
        <div
          className="phone-section-left"
          style={{
            display: "flex",
            minWidth: "600px",
            padding: "4rem 0",
            justifyContent: "center",
            gap: "2rem",
            flexDirection: "column",
            alignItems: "start",
            flex: "1",
            height: "auto",
          }}
        >
          <h3
            style={{
              color: "black",
              fontSize: "3.2rem", // text-3xl
              fontWeight: 600, // font-semibold
              lineHeight: "normal",
            }}
          >
            Save Big, Earn More, and Learn Along the Way!
          </h3>
          <p>
            Discover the best Exclusive Deals via the Pocket Deal app, earn
            rewards through referrals, and join our skill-building workshops
            that prepare you for success in hospitality.
          </p>
          <button
            style={{
              backgroundColor: isHovered ? "white" : "#f15623",
              border: "2px solid #f15623",
              color: isHovered ? "black" : "white",
              fontSize: "1.125rem",
              fontWeight: 600,
              padding: "12px 20px",
              borderRadius: "8px",
              display: "inline-block",
              marginTop: "1.75rem",
              transition: "all 1s ease-in-out",
              cursor: "pointer",
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            Sign Up to Learn and Earn!
          </button>
        </div>
        <div
          className="phone-section-right"
          style={{
            display: "flex",
            justifyContent: "center",
            flex: "1",
          }}
        >
          <img
            src="/images/phone22.png"
            style={{
              marginTop: "-4rem",
              zIndex: "5",
              width: "36rem",
              margin: "auto",
            }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default PhoneSection;
